import CampaignHead from '@components/campaign-head/campaign-head.component'
import CampaignStatusBar from '@components/campaign-status-bar/campaign-status-bar.component'
import { Campaign, UserInCampaign } from '@hub/shared'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './campaign-tiny-card.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  users?: UserInCampaign
  type?: string
}

export default ({ className = '', style = {}, id = '', campaign, users, type }: Props) => {
  const [link, setLink] = useState<string>('')

  useEffect(() => {
    if (users?.interested?.length) {
      setLink(`/campaigns/${campaign._id}/summary?idNetwork=${users?.interested[0]?.id || users?.interested[0]?.idProfile}`)
    } else if (users?.refuseds?.length) {
      setLink(`/campaigns/${campaign._id}/summary?idNetwork=${users?.refuseds[0]?.id || users?.refuseds[0]?.idProfile}`)
    } else if (users?.invited?.length) {
      setLink(`/campaigns/${campaign._id}/summary?idNetwork=${users?.invited[0]?.id || users?.invited[0]?.idProfile}`)
    } else if (users?.inContact?.length) {
      setLink(`/campaigns/${campaign._id}/summary?idNetwork=${users?.inContact[0]?.id || users?.inContact[0]?.idProfile}`)
    } else if (users?.hasProfile?.length) {
      setLink(`/campaigns/${campaign._id}/summary?idNetwork=${users?.hasProfile[0]?.id || users?.hasProfile[0]?.idProfile}`)
    } else if (users?.recruited?.length) {
      const origin = !location.pathname.endsWith('campaigns') ? location.pathname?.split('/').pop() : undefined
      setLink(
        `/campaigns/${campaign._id}/details/${users?.recruited[0].id || users?.recruited[0]?.idProfile}?${origin ? `origin=${origin}` : ''}`
      )
    } else {
      setLink(`/campaigns/${campaign._id}/summary`)
    }
  }, [campaign, users])

  return (
    <Link to={link} className={`campaign-tiny-card ${className}`} style={style} id={id}>
      <div className="box head">
        <CampaignHead campaign={campaign} mode="tiny" />
      </div>
      {!['finished', 'archived'].includes(campaign?.status) ? (
        <CampaignStatusBar campaign={campaign} users={users} style={{ marginTop: 'auto' }} type={type} />
      ) : null}
    </Link>
  )
}
